<div class="container">
    <div class="mobile-header__body">
        <button class="mobile-header__menu-button" type="button" (click)="menu.open()">
            <app-icon icon="menu-18x14"></app-icon>
        </button>
        <a class="mobile-header__logo" routerLink="/">
            <app-mobile-logo></app-mobile-logo>
        </a>
        <div class="mobile-header__search mobile-search" [class.mobile-header__search--open]="searchIsOpen" #searchForm>
            <form class="mobile-search__body" (submit)="$event.preventDefault()">
                <label class="sr-only" for="mobile-site-search">{{ 'INPUT_SEARCH_LABEL'|translate }}</label>
                <input type="text" id="mobile-site-search" class="mobile-search__input"
                    [placeholder]="searchPlaceholder$|async" (focus)="onInputFocus($event)" (input)="onInput($event)"
                    #searchInput>
                <button type="button" class="mobile-search__vehicle-picker" (click)="openVehiclePicker()">
                    <app-icon icon="bike-20"></app-icon>
                    <span class="mobile-search__vehicle-picker-label"></span>
                </button>
                <button type="submit" class="mobile-search__button mobile-search__button--search">
                    <app-icon icon="search-20"></app-icon>
                </button>
                <button type="button" class="mobile-search__button mobile-search__button--close"
                    (click)="closeSearch()">
                    <app-icon icon="cross-20"></app-icon>
                </button>
                <div class="mobile-search__field"></div>
            </form>
            <div class="search__dropdown search__dropdown--suggestions suggestions"
                [class.search__dropdown--open]="suggestionsIsOpen && hasSuggestions">
                <div class="suggestions__group" *ngIf="products.length > 0">
                    <div class="suggestions__group-title">{{ 'TEXT_PRODUCTS'|translate }}</div>
                    <div class="suggestions__group-content">
                        <a *ngFor="let product of products" class="suggestions__item suggestions__product"
                            [routerLink]="url.product(product)" (click)="toggleSuggestions(false)">
                            <div class="suggestions__product-image">
                                <img [src]="product.images[0]" alt="">
                            </div>
                            <div class="suggestions__product-info">
                                <div class="suggestions__product-name">
                                    {{ product.name }}
                                </div>
                            </div>
                            <div class="suggestions__product-price">
                                {{ product.price|currencyFormat }}
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <div class="mobile-header__indicators">
            <div class="mobile-indicator d-md-none" #searchIndicator>
                <button type="button" class="mobile-indicator__button" (click)="openSearch()">
                    <span class="mobile-indicator__icon">
                        <app-icon icon="search-20"></app-icon>
                    </span>
                </button>
            </div>
            <div class="mobile-indicator d-none d-md-block">
                <a routerLink="/account" class="mobile-indicator__button">
                    <span class="mobile-indicator__icon">
                        <app-icon icon="person-20"></app-icon>
                    </span>
                </a>
            </div>
            <div class="mobile-indicator d-none d-md-block">
                <a routerLink="/shop/wishlist" class="mobile-indicator__button">
                    <span class="mobile-indicator__icon">
                        <app-icon icon="heart-20"></app-icon>
                        <span *ngIf="(wishlist.count$|async) > 0" class="mobile-indicator__counter">{{
                            wishlist.count$|async }}</span>
                    </span>
                </a>
            </div>
            <div class="mobile-indicator">
                <a routerLink="/shop/cart" class="mobile-indicator__button">
                    <span class="mobile-indicator__icon">
                        <app-icon icon="cart-20"></app-icon>
                        <span *ngIf="(cart.quantity$|async) > 0" class="mobile-indicator__counter">{{
                            cart.quantity$|async }}</span>
                    </span>
                </a>
            </div>
        </div>
    </div>
</div>